'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalize;
/**
 * Captialize a string
 * @ignore
 * @param {string} string
 * @return {string}
 */
function capitalize(string) {
  return typeof string === 'string' ? string.charAt(0).toUpperCase() + string.slice(1) : string;
}
//# sourceMappingURL=capitalize.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/capitalize.js